import React, { useState, useRef, useEffect } from "react";
import styles from "./TournamentTypeSelect.module.scss";
import ArrowDownIcon from "@/assets/icons/arrowDown.svg";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import { selectTournamentTypes } from "@/redux/tournaments/selectors";
import { fetchGetTournamentTypes } from "@/redux/tournaments/asyncActions";

interface TournamentTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export const TournamentTypeSelect: React.FC<TournamentTypeSelectProps> = ({
  value,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const tournamentTypes = useAppSelector(selectTournamentTypes);

  useEffect(() => {
    if (tournamentTypes.length === 0) {
      dispatch(fetchGetTournamentTypes());
    }
  }, [dispatch, tournamentTypes.length]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (type: string) => {
    onChange(type);
    setIsOpen(false);
  };

  return (
    <div className={styles.container} ref={dropdownRef}>
      <button
        type="button"
        className={styles.selectButton}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={styles.selectButtonText}>
          {value || "Выберите тип"}
        </span>
        <img
          src={ArrowDownIcon}
          alt="arrow down"
          className={`${styles.arrowIcon} ${isOpen ? styles.arrowIconOpen : ""}`}
        />
      </button>
      {isOpen && (
        <div className={styles.dropdown}>
          {tournamentTypes.map((type) => (
            <button
              key={type}
              type="button"
              className={`${styles.dropdownItem} ${value === type ? styles.dropdownItemSelected : ""}`}
              onClick={() => handleSelect(type)}
            >
              {type}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
